import { FC } from "react";
import { useTheme } from "styled-components";
import { HeaderOneCont } from "./styled.styles";
import { useLink2 } from "contexts/SeoContext";
import IconPhone from "assets/icons/IconPhone";
import { gtmLanguageBtn } from "GTMs/actions/commonActions";
import useGetCountry from "hooks/useGetCountry";
import { linkToSupport } from "helpers/links-builders/help";
import SwitchLangAnchor from "componentReusable/SwitchLangAnchor";
import { useRouter } from "next/router";

const HeaderOneDesktop: FC = () => {
  let { translations, isChangeCountryPage } = useTheme();
  const countryData = useGetCountry();
  const router = useRouter();
  const ref = router?.query["ref"] as string;
  const country = ref?.split("_")?.[2];
  const link2 = useLink2();
  const getPhoneNumber = () => {
    if (isChangeCountryPage) {
      if (country !== countryData?.abbreviation) {
        return {
          href: `tel:${countryData?.contact_info?.phone_number}`,
          phoneNumber: countryData?.contact_info?.phone_number,
        };
      } else if (countryData?.contact_info?.os_phone_number !== null) {
        return {
          href: `tel:${countryData?.contact_info?.os_phone_number}`,
          phoneNumber: countryData?.contact_info?.os_phone_number,
        };
      } else if (countryData?.contact_info?.phone_number) {
        return {
          href: `tel:${countryData?.contact_info?.phone_number}`,
          phoneNumber: countryData?.contact_info?.phone_number,
        };
      }
    } else if (countryData?.contact_info?.os_phone_number) {
      return {
        href: `tel:${countryData?.contact_info?.os_phone_number}`,
        phoneNumber: countryData?.contact_info?.os_phone_number,
      };
    } else {
      return { href: linkToSupport() };
    }
  };
  const { href, phoneNumber } = getPhoneNumber();
  return (
    <HeaderOneCont id="headerOneDesktop" className="grayBg pt-8 pb-8">
      <div className="width-1200 m-auto ta-e">
        {phoneNumber ? (
          <a href={href} className="ltr blackColor bold inline withPhone">
            <IconPhone fill="#0179FF" width="15" height="15" /> {phoneNumber}
          </a>
        ) : (
          <a href={href} className="blackColor bold inline">
            {translations.contactUs}{" "}
            <IconPhone fill="#0179FF" width="15" height="15" />
          </a>
        )}
        <hr className="ms-8 me-8 inline vMiddle" />
        <SwitchLangAnchor
          id="change_lang_link"
          href={link2}
          className="blackColor bold"
          onClick={gtmLanguageBtn}
        >
          {translations.language}
        </SwitchLangAnchor>
      </div>
    </HeaderOneCont>
  );
};

export default HeaderOneDesktop;
